const DEFAULT_EXPERIMENT_ID = 'plp_v2_sections_2026_08'
const EXPOSURE_EVENT = 'experiment_exposure'
const BANNER_SELECTOR = '[data-plp-experiment-section="shorter-collection-banner-v2"], .js-shorter-banner-v2'
const SUB_COLLECTION_SELECTOR = '[data-plp-experiment-section="sub-collections-v2"], .carousel-swiper-sub-collection'

function getCollectionHandle() {
  const path = window.location.pathname || ''
  const collectionMatch = path.match(/^\/collections\/([^/]+)/)
  return collectionMatch ? collectionMatch[1] : ''
}

function isCollectionPage() {
  const templateName = window.GM_STATE?.shopify?.templateName
  return templateName === 'collection' || window.location.pathname.indexOf('/collections/') === 0
}

function getTrackingConfig() {
  const config = window.GM_STATE?.integrations?.plpExperimentTracking || {}

  return {
    enabled: config.enabled === true,
    experimentId: config.experimentId || DEFAULT_EXPERIMENT_ID
  }
}

export function getPlpExperimentContext() {
  const config = getTrackingConfig()
  const hasShorterCollectionBannerV2 = Boolean(document.querySelector(BANNER_SELECTOR))
  const hasSubCollectionsV2 = Boolean(document.querySelector(SUB_COLLECTION_SELECTOR))
  const isV2Cohort = hasShorterCollectionBannerV2 && hasSubCollectionsV2

  return {
    enabled: config.enabled,
    isCollectionPage: isCollectionPage(),
    experimentId: config.experimentId,
    variantId: isV2Cohort ? 'v2_sections' : 'control_no_v2_sections',
    collectionHandle: getCollectionHandle(),
    hasShorterCollectionBannerV2,
    hasSubCollectionsV2
  }
}

export function isPlpExperimentTrackingEnabled() {
  const context = getPlpExperimentContext()
  return context.enabled && context.isCollectionPage
}

export function pushPlpExperimentEvent(eventName, payload = {}) {
  const context = getPlpExperimentContext()
  if (!context.enabled || !context.isCollectionPage) return false

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventName,
    experiment_id: context.experimentId,
    variant_id: context.variantId,
    collection_handle: context.collectionHandle,
    has_shorter_collection_banner_v2: context.hasShorterCollectionBannerV2,
    has_sub_collections_v2: context.hasSubCollectionsV2,
    ...payload
  })

  return true
}

export function trackPlpExperimentExposure() {
  const context = getPlpExperimentContext()
  if (!context.enabled || !context.isCollectionPage) return false

  const storageKey = [
    'plp-experiment-exposure',
    context.experimentId,
    context.collectionHandle,
    context.variantId
  ].join(':')

  try {
    if (window.sessionStorage.getItem(storageKey) === '1') {
      return false
    }
    window.sessionStorage.setItem(storageKey, '1')
  } catch (_error) {
    // Ignore storage access issues and continue tracking exposure.
  }

  return pushPlpExperimentEvent(EXPOSURE_EVENT)
}
